import {Injectable, Optional} from "@angular/core";
import {DataResourceModel, EntityData} from "@fedeltapointofsale/data-client";
import {EditGridComponent} from "./edit-grid.component";
import {Subject} from "rxjs";

export enum CellActivationMode {
    FOCUS,
    CLICK
}

export class WrappedString extends String {
    private readonly _value: any;

    constructor(value: any) {
        super(value);
        this._value = value;
    }

    get value(): string {
        return this._value;
    }
}

export class WrappedBoolean extends Boolean {
    private readonly _value: any;

    constructor(value: any) {
        super(value);
        this._value = value;
    }

    get value(): boolean {
        return this._value;
    }
}

export class WrappedNumber extends Number {
    private readonly _value: any;

    constructor(value: any) {
        super(value);
        this._value = value;
    }

    get value(): number {
        return this._value;
    }
}

/**
 * Provides some functions for entity column edit
 */
@Injectable()
export class EditGridService {
    data: any[];
    primitive: boolean;
    isEntityData: boolean;

    editGrid: EditGridComponent;

    _columnFocus$: Subject<number>

    constructor(@Optional() public model: DataResourceModel<any>) {
        this._columnFocus$ = new Subject();
    }

    get columnFocus$() {
        return this._columnFocus$;
    }

    getFieldPath(path: string[]): string {
        return path.join(".").replace("_", ".");
    }

    createEntity(): EntityData<any> | any {
        return this.editGrid.createEntity();
    }

    refreshGridData(): void {
        this.editGrid.refreshGridData();
    }

    addRow(entityData: EntityData<any> | any): number {
        return this.editGrid.addRow(entityData);
    }

    editRow(rowIndex: number, entityData: EntityData<any> | any, isNewRow: boolean = false): void {
        if (this.editGrid.gridFormTemplateRef && (!isNewRow || this.editGrid.showEditRowFormOnAdd)) {
            this.editGrid.editRowForm(entityData, rowIndex, isNewRow);
        } else {
            this.editGrid.editRow(entityData, rowIndex, isNewRow)
        }
    }

    get editable(): boolean {
        return this.editGrid.editable;
    }

    setupCellActivation(cellActivationMode: CellActivationMode, columnIndex: number): void {
        this.editGrid.cellActivationMode = cellActivationMode;
        this.editGrid.editingColumnIndex = columnIndex;
    }

    clearCellActivation() {
        this.editGrid.cellActivationMode = undefined;
    }

    get cellActivationMode() {
        return this.editGrid.cellActivationMode;
    }

    get editingColumnIndex() {
        return this.editGrid.editingColumnIndex;
    }

    set editingColumnIndex(editingColumnIndex: number) {
        this.editGrid.editingColumnIndex = editingColumnIndex;
    }

    focusOnColumn(columnIndex: number) {
        this._columnFocus$.next(columnIndex);
    }
}
